import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button, PrimaryButton } from "../../../ui/Button/Button";
import { vehicleLoaderFormId } from "../VehicleMapping/VehicleLoader";
import { packageInfoEditFormId } from "./PackageInfo";

export const Footer: FunctionComponent<{
  forceVehicleLoaderMode: boolean;
  hide: VoidFunction;
  isSending: boolean;
  modelsAreLoading: boolean;
  selectTab: (index: number) => void;
  setForceVehicleLoaderMode: (mode: boolean) => void;
  shoulDisableFetchVehiclesButton: boolean;
  tabIndex: number;
}> = ({
  forceVehicleLoaderMode,
  hide,
  isSending,
  modelsAreLoading,
  selectTab,
  setForceVehicleLoaderMode,
  shoulDisableFetchVehiclesButton,
  tabIndex,
}) => {
  const { t } = useTranslation();
  return (
    <footer className="new-package-dialog__footer">
      {tabIndex === 0 && (
        <>
          <Button aria-label="close" onClick={hide}>
            {t("packageEditor.close")}
          </Button>
          <PrimaryButton
            onClick={(): void => {
              selectTab(1);
            }}
            aria-label="save"
          >
            {t("packageEditor.next")}
          </PrimaryButton>
        </>
      )}
      {tabIndex === 1 &&
        (forceVehicleLoaderMode ? (
          <>
            <Button
              onClick={(): void => {
                setForceVehicleLoaderMode(false);
              }}
              aria-label="close"
            >
              {t("packageEditor.vehicles")}
            </Button>
            <PrimaryButton
              aria-label="save"
              busy={modelsAreLoading}
              disabled={shoulDisableFetchVehiclesButton}
              form={vehicleLoaderFormId}
              type="submit"
            >
              {t("packageEditor.fetchVehicles")}
            </PrimaryButton>
          </>
        ) : (
          <>
            <Button
              onClick={(): void => {
                selectTab(0);
              }}
              aria-label="close"
            >
              {t("packageEditor.parts")}
            </Button>
            <PrimaryButton
              onClick={(): void => {
                selectTab(2);
              }}
              aria-label="save"
            >
              {t("packageEditor.next")}
            </PrimaryButton>
          </>
        ))}
      {tabIndex === 2 && (
        <>
          <Button
            onClick={(): void => {
              selectTab(1);
            }}
            aria-label="close"
          >
            {t("packageEditor.vehicles")}
          </Button>
          <PrimaryButton
            aria-label="save"
            busy={isSending}
            form={packageInfoEditFormId}
            type="submit"
          >
            {t("packageEditor.updatePackage")}
          </PrimaryButton>
        </>
      )}
    </footer>
  );
};
